<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/projects' }" style="color: #5daf34">{{ this.projectName }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/project/'+this.$route.params.projectID+'/service'}"
                          style="color: #5daf34">{{ this.serviceName }}
      </el-breadcrumb-item>
      <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <br/>
    <div>
      <div style="float: left;">
        <h1> 警报列表</h1>
      </div>
      <div style="float: right;">
        <el-button @click="addHandler" icon="el-icon-plus" type="primary">添加新警报信息</el-button>
      </div>
    </div>

    <br/>
    <br/>
    <br/>

    <el-table
        :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">

      <el-table-column
          label="警报级别"
          prop="level"
          width="100">
        <template slot-scope="scope">
          <el-tooltip :content="(scope.row.level===levelMap[1] ? '日志记录' : (scope.row.level===levelMap[2] ? '邮件通知' : (scope.row.level===levelMap[3] ? 'WOA通知' : (scope.row.level===levelMap[4] ? '电话通知': '电话通知'))))" placement="top">
            <el-tag
                :type="(scope.row.level===levelMap[1] ? 'info' : (scope.row.level===levelMap[2] ? '' : (scope.row.level===levelMap[3] ? 'warning' : (scope.row.level===levelMap[4] ? 'danger': 'danger'))))"
                class="keyWordTag"
                effect="dark">
              {{ scope.row.level }}
            </el-tag>
          </el-tooltip>

        </template>
      </el-table-column>

      <el-table-column
          label="警报名"
          prop="name"
          width="150">
        <template scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column
          label="警报描述"
          prop="description"
          width="300">
      </el-table-column>


      <el-table-column
          label="用户组"
          width="300">
        <template slot-scope="scope">
          <el-tag :key="userGroupName" class="keyWordTag" v-for="userGroupName in scope.row.userGroupNames">
            {{ userGroupName }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
          label="关键字"
          width="400">
        <template slot-scope="scope">
          <el-tag :key="keyWord" class="keyWordTag" type="success" v-for="keyWord in scope.row.keyWords">{{
              keyWord
            }}
          </el-tag>
          <el-tag :key="keyWord" class="keyWordTag" type="danger" v-for="keyWord in scope.row.badKeys">{{
              keyWord
            }}
          </el-tag>

        </template>
      </el-table-column>

      <el-table-column
          :render-header="renderTipsHeader"
          label="优先级"
          prop="weight"
          width="90">

      </el-table-column>

      <el-table-column
          label="警报状态"
          width="100">
        <template slot-scope="scope">
          <el-tag
              :type="(scope.row.status===statusMap[1] ? 'success' : (scope.row.status===statusMap[2] ? 'danger' : 'danger'))"
              class="keyWordTag">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column align="right" width="200">
        <template slot="header" slot-scope="{}">
          <el-input
              placeholder="输入警报名称搜索"
              size="mini"
              v-model="search"/>
        </template>
        <template slot-scope="scope">
          <el-button
              @click="editHandler(scope.row,scope.$index)"
              plain
              size="mini"
              type="primary">编辑
          </el-button>

          <el-button
              @click="viewAlert(scope.row)"
              size="mini"
              type="info">查看监控
          </el-button>

        </template>

      </el-table-column>
    </el-table>


    <el-dialog :visible.sync="formVisible" title="警报信息">
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth" label="警报id" v-show="inputVisible">
          <el-input :disabled="true" v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报名称" prop="alertName">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报描述">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报创建者" v-show="inputVisible">
          <el-input :disabled="true" v-model="form.ownerName"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报所属项目" v-show="inputVisible">
          <el-input :disabled="true" v-model="form.projectName"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报所属服务" v-show="inputVisible">
          <el-input :disabled="true" v-model="form.serviceName"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="警报创建时间" v-show="inputVisible">
          <el-input :disabled="true" v-model="form.createTime"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="初始警报级别">
          <el-select placeholder="请选择初始警报级别" v-model="form.levelValue">
            <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in levelOptions">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="初始警报优先级">
          <el-select placeholder="请选择初始警报优先级" v-model="form.weight">
            <el-option
                :key="weight"
                :label="weight"
                :value="weight"
                v-for="weight in 100">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item :label-width="formLabelWidth" label="警报开关">
          <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-model="mute">
          </el-switch>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="用户组">
          <el-select multiple placeholder="请选择警报关联的用户组" v-model="form.userGroupIDS">
            <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in userGroups">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="关键词">
          <el-tag
              :disable-transitions="false"
              :key="tag"
              @close="handleClose(tag)"
              closable
              type="success"
              v-for="tag in form.keyWords">
            {{ tag }}
          </el-tag>
          <el-input
              @blur="handleInputConfirm"
              @keyup.enter.native="handleInputConfirm"
              class="input-new-tag"
              ref="saveTagInput"
              size="small"
              v-if="TagInputVisible"
              v-model="TagInputValue">
          </el-input>
          <el-button :disabled="keyVisible" @click="showInput" class="button-new-tag" size="small" v-else>新增关键词
          </el-button>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="不包含关键词">
          <el-tag
              :disable-transitions="false"
              :key="tag"
              @close="handleCloseForB(tag)"
              closable
              type="danger"
              v-for="tag in form.badKeys">
            {{ tag }}
          </el-tag>
          <el-input
              @blur="handleInputConfirmForB"
              @keyup.enter.native="handleInputConfirmForB"
              class="input-new-tag"
              ref="saveTagInput"
              size="small"
              v-if="TagInputVisibleForB"
              v-model="TagInputValueForB">
          </el-input>
          <el-button :disabled="keyVisibleForB" @click="showInputForB" class="button-new-tag" size="small" v-else>
            新增关键词
          </el-button>
        </el-form-item>

        <el-divider></el-divider>
        <el-form-item :label-width="formLabelWidth" label="等级重置规则">
          <el-input placeholder="每多少时间" v-model="form.timeThreshold"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-select placeholder="请选择时间单位" v-model="form.timeType">
            <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in timeOptions">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth">
          <el-input placeholder="触发多少次" v-model="form.countThreshold"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth">
          <el-select placeholder="选择重置的警报级别" v-model="form.resetLevel">
            <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in levelOptions">
            </el-option>
          </el-select>
          <el-button @click="addAlertRuleFront" plain type="primary">添加</el-button>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="规则样例：">
          <a>每 <strong>30</strong> <strong>分钟</strong> 触发 <strong>3</strong> 次 就将警报重置为 <strong>警告</strong> </a>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="警报规则表">
          <span style="margin-right: 10px;"></span>
          <el-table :data="ruleTable"
                    border
                    style="width: 100%">
            <el-table-column
                label="时间"
                prop="timeThreshold"
                width="100">
            </el-table-column>
            <el-table-column
                label="时间类型"
                prop="timeType"
                width="100">
            </el-table-column>
            <el-table-column
                label="触发次数"
                prop="countThreshold"
                width="100">
            </el-table-column>
            <el-table-column
                label="重置为"
                prop="resetLevel"
                width="180">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                    @click="deleteAlertRuleFront(scope.$index)"
                    size="mini"
                    type="danger">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="formVisible=false">取 消</el-button>
        <el-button @click="confirmHandler" type="primary">确 定</el-button>
        <el-button @click="deleteAlert" type="danger" v-if="form.id">删 除</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {Apis} from "@/api";

export default {
  data() {
    return {
      levelMap: {1: '信息', 2: '警告', 3: '错误', 4: '致命'},
      statusMap: {1: '正常', 2: '静音'},

      normalAlert: 1, //正常警报
      defaultAlert: 2, //默认警报

      levelOptions: [{
        value: 1,
        label: '信息-日志记录'
      }, {
        value: 2,
        label: '警告-邮件'
      }, {
        value: 3,
        label: '错误-WOA'
      }, {
        value: 4,
        label: '致命-电话'
      }],
      timeOptions: [{
        value: 1,
        label: '秒'
      }, {
        value: 2,
        label: '分钟'
      }, {
        value: 3,
        label: '小时'
      }],
      formLabelWidth: '120px',

      search: "",
      projectName: "",
      serviceName: "",

      userGroups: [], //公用的用户组数据
      TagInputVisibleForB: false,
      TagInputValueForB: '',
      keyVisibleForB: false,

      TagInputVisible: false,
      TagInputValue: '',
      keyVisible: false,

      // 主页面列表数据
      tableData: [{
        id: "",
        name: "",
        description: "",
        ownerName: "",
        projectName: "",
        serviceName: "",
        keyWords: [],
        badKeys: [],
        type: -1,
        level: "",
        status: "",
        levelValue: "",
        statusValue: "",
        createTime: "",
        userGroupNames: [],
        userGroupIDS: [],

        weight: 0,
      }],

      formVisible: false,
      inputVisible: false,
      mute: true,
      ruleTable: [],
      index: 0,

      form: {
        id: "",
        name: "",
        description: "",
        ownerName: "",
        projectName: "",
        serviceName: "",
        badKeys: [],
        keyWords: [],

        type: 1,
        level: "",
        status: "",
        levelValue: "",
        statusValue: "",
        createTime: "",
        timeThreshold: '',
        timeType: '',
        countThreshold: '',
        resetLevel: '',
        userGroupNames: [],
        userGroupIDS: [],

        weight: 50,
      },
    }
  },
  methods: {
    renderTipsHeader(h, {column}) {
      return h(
          'div', [
            h('span', column.label),
            h('el-tooltip', {
              props: {
                effect: 'dark',
                content: '满足多条警报规则情况下, 优先级 > 告警等级 > 创建时间',
                placement: 'top',
              },
            }, [
              h('i', {
                class: 'el-icon-question',
                style: 'color:#409EFF;margin-left:5px;'
              })
            ])
          ]
      );
    },
    sortWeight(a, b) {
      return b.weight - a.weight
    },
    //--------------------------前端函数-----------------------------------//
    resetRuleForm(){
      this.form.timeThreshold=''
      this.form.timeType=''
      this.form.countThreshold=''
      this.form.resetLevel=''
    },
    viewAlert(row) {
      const projectID = this.$route.params.projectID
      const serviceID = this.$route.params.serviceID
      // console.log(projectID)
      // console.log(serviceID)

      //最近24小时
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);

      // console.log(start.getTime(),end)
      const URL = '/search' + '/' + start.getTime() + '/' + end.getTime() + "/" + projectID + '/' + serviceID + '/' + row.id + '/-1'

      //打开新监控窗口
      const routeUrl = this.$router.resolve({
        path: URL,
        query: {}
      });
      window.open(routeUrl.href, '_blank');

    },
    //删除规则表中的规则
    deleteAlertRuleFront(index) {
      this.ruleTable.splice(index, 1)
    },

    //增加规则到规则表中
    addAlertRuleFront() {
      if (this.form.timeThreshold === "" || this.form.timeType === "" || this.form.countThreshold === "" || this.form.resetLevel === "" || this.form.timeThreshold === undefined || this.form.timeType === undefined || this.form.countThreshold === undefined || this.form.resetLevel === undefined) {
        this.$message.error("空的警报规则不能添加");
        return
      }
      this.ruleTable.push({
        timeThreshold: this.form.timeThreshold,
        countThreshold: this.form.countThreshold,
        timeType: this.timeOptions[parseInt(this.form.timeType) - 1].label,
        resetLevel: this.levelOptions[parseInt(this.form.resetLevel) - 1].label,

        timeTypeValue: this.timeOptions[parseInt(this.form.timeType) - 1].value,
        resetLevelValue: this.levelOptions[parseInt(this.form.resetLevel) - 1].value,
      })
      //清空数据
      this.resetRuleForm()
    },

    handleClose(tag) {
      this.form.keyWords.splice(this.form.keyWords.indexOf(tag), 1);
    },
    showInput() {
      this.TagInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.TagInputValue;
      if (inputValue) {
        this.form.keyWords.push(inputValue);
      }
      this.TagInputVisible = false;
      this.TagInputValue = '';
    },
    handleCloseForB(tag) {
      this.form.badKeys.splice(this.form.badKeys.indexOf(tag), 1);
    },
    showInputForB() {
      this.TagInputVisibleForB = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirmForB() {
      const inputValue = this.TagInputValueForB;
      if (inputValue) {
        this.form.badKeys.push(inputValue);
      }
      this.TagInputVisibleForB = false;
      this.TagInputValueForB = '';
    },

    //-----------------------------后端函数----------------------------------------//
    //表单确认按钮的Handler
    async confirmHandler() {
      //正常警报，默认警报都有的限制
      if (this.form.name === "" || this.form.description === "" || this.form.levelValue === "") {
        this.$message.error("警报名称，警报描述，初始警报级别,都不能为空！");
        return
      }

      // 避免null，调用length属性
      this.form.userGroupIDS = this.form.userGroupIDS || []
      this.form.badKeys = this.form.badKeys || []
      this.form.keyWords = this.form.keyWords || []

      //正常警报限制：只有警报级别为信息的时候才可以不选择用户组
      if (this.form.levelValue !== 1 && this.form.userGroupIDS.length === 0 && this.form.type === this.normalAlert) {
        this.$message.error("正常警报：只有警报级别为信息的时候才可以不选择用户组");
        // console.log(this.form.type)
        return
      }
      //正常警报限制：关键字为必填选项
      if (this.form.type === this.normalAlert && this.form.keyWords.length === 0) {
        this.$message.error("关键字为必填选项");
        return
      }

      //不同界面对应不同逻辑
      if (this.inputVisible === false) {
        //添加警报
        await this.addAlert();
        //仅当存在警报规则的时候才去调用后端api添加警报规则
        this.ruleTable = this.ruleTable || []
        if (this.ruleTable.length > 0) {
          //添加警报规则
          await this.addAlertRule(this.form.id)
        }
      } else {
        //更新警报
        await this.updateAlert()
        //更新警报规则
        await this.updateAlertRule()
      }
      //隐藏弹窗界面
      this.formVisible = false
      //字段清空
      this.resetForm()
    },

    // 删除警报
    async deleteAlert() {
      this.$confirm('此操作将永久删除告警信息及其下属的告警规则, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await Apis.Alert.deleteAlert(this.form.id)
        // console.log(response)
        if (response != null && response.errno === 0) {
          this.$message.success("警报删除成功!");
          this.tableData.splice(this.index, 1)
          this.formVisible = false
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //添加警报
    async addAlert() {
      let _status = 1;
      if (this.mute === false) {
        _status = 2
      }
      this.form.badKeys = this.form.badKeys ?? []
      this.form.keyWords = this.form.keyWords ?? []

      const response = await Apis.Alert.addAlert(this.form.name, this.form.description, parseInt(this.$route.params.projectID), parseInt(this.$route.params.serviceID), this.form.levelValue, _status, this.form.userGroupIDS, this.form.keyWords, this.form.badKeys, this.form.weight)
      if (response != null && response.errno === 0) {
        this.$message.success("告警信息添加成功!");
        const alert = response.data;
        this.tableData = this.tableData || []
        this.tableData.unshift({
          id: alert.id,
          name: alert.name,
          description: alert.description,
          ownerName: alert.ownerName,
          projectName: alert.projectName,
          serviceName: alert.serviceName,
          token: alert.token,
          level: alert.level,
          levelValue: alert.levelValue,
          status: alert.status,
          createTime: alert.createTime,
          userGroupNames: alert.userGroupNames,
          userGroupIDS: alert.userGroupIDS,
          badKeys: alert.badKeys,
          keyWords: alert.keyWords,

          weight: alert.weight,
        })
        this.form.id = alert.id
      }

      //添加新警报之后按照weight重新排序
      this.tableData.sort(this.sortWeight)
    },
    //更新警报
    async updateAlert() {
      let _status = 1;
      if (this.mute === false) {
        _status = 2
      }
      // console.log(this.form.levelValue)
      this.form.keyWords = this.form.keyWords ?? []
      this.form.badKeys = this.form.badKeys ?? []

      const response = await Apis.Alert.updateAlert(this.form.id, this.form.name, this.form.description, this.form.levelValue, _status, this.form.userGroupIDS, this.form.keyWords, this.form.badKeys, this.form.weight)
      if (response != null && response.errno === 0) {
        this.$message.success("告警信息更新成功!");
        //根据map生成对应的文案
        this.form.level = this.levelMap[this.form.levelValue]
        this.form.statusValue = 1
        if (this.mute === false) {
          this.form.statusValue = 2
        }
        this.form.status = this.statusMap[this.form.statusValue]

        this.form.userGroupNames = []
        for (let i = 0; i < this.form.userGroupIDS.length; i++) {
          this.form.userGroupNames.push(this.getUerGroupNameByID(this.form.userGroupIDS[i]))
        }
        //更新列表中原有的值(复制)
        this.tableData[this.index] = JSON.parse(JSON.stringify(this.form))
        // console.log(this.form)
        // console.log(this.tableData[this.index])

        //修改之后按照weight重新排序
        this.tableData.sort(this.sortWeight)
      }
    },
    //更新警报规则
    async updateAlertRule() {
      //组装发送数据
      const alertRules = [];
      this.ruleTable = this.ruleTable || []
      let alertRule;
      for (let i = 0; i < this.ruleTable.length; i++) {
        alertRule = this.ruleTable[i]
        alertRules.push({
          timeThreshold: parseInt(alertRule.timeThreshold),
          countThreshold: parseInt(alertRule.countThreshold),
          timeType: parseInt(alertRule.timeTypeValue),
          resetLevel: parseInt(alertRule.resetLevelValue),
        })
      }
      //发送
      const response = await Apis.AlertRule.updateAlertRule(this.form.id, alertRules)
      if (response != null && response.errno === 0) {
        this.$message.success("告警规则信息更新成功!");
      }
    },
    //添加警报规则
    async addAlertRule(alertID) {
      let flag = 0;
      let temp;
      this.ruleTable = this.ruleTable || []
      for (let i = 0; i < this.ruleTable.length; i++) {
        temp = this.ruleTable[i]
        const response = await Apis.AlertRule.addAlertRule(alertID, parseInt(temp.timeThreshold), parseInt(temp.countThreshold), parseInt(temp.timeTypeValue), parseInt(temp.resetLevelValue))
        if (response != null && response.errno === 0) {
          flag = flag + 1
        }
      }
      if (flag === this.ruleTable.length) {
        this.$message.success("告警规则添加成功!");
      }
    },
    //------------------------------工具函数--------------------------------------//
    //表单字段清空
    resetForm() {
      this.form.id = ""
      this.form.name = ""
      this.form.description = ""
      this.form.ownerName = ""
      this.form.projectName = ""
      this.form.serviceName = ""
      this.form.token = ""
      this.form.level = ""
      this.form.status = ""
      this.form.levelValue = ""
      this.form.statusValue = ""
      this.form.createTime = ""
      this.mute = true
      this.form.timeThreshold = ""
      this.form.timeType = ""
      this.form.countThreshold = ""
      this.form.resetLevel = ""
      this.ruleTable = []
      this.form.userGroupNames = []
      this.form.userGroupIDS = []
      this.form.keyWords = []
      this.form.badKeys = []
      this.form.inputVisible = false
      this.form.inputValue = ''
      this.form.weight = 50

      this.keyVisibleForB = false
      this.keyVisible = false
    },
    //通过用户组ID获得用户组的名字
    getUerGroupNameByID(userGroupID) {
      for (let i = 0; i < this.userGroups.length; i++) {
        if (this.userGroups[i].id === userGroupID) {
          return this.userGroups[i].name
        }
      }
    },
    //------------------------------界面初始化函数--------------------------------//
    //进入 添加页面 的 初始化函数
    addHandler() {
      //字段重置
      this.resetForm()
      // 弹窗可见，隐藏部分输入框
      this.formVisible = true
      this.inputVisible = false
    },
    //进入 编辑页面 的 初始化函数
    editHandler(row, index) {
      //字段清空
      this.resetForm()
      //根据列表警报状态，决定开关的值
      this.mute = row.status !== ("静音");
      // 复制行数据
      this.form = JSON.parse(JSON.stringify(row))
      //设置弹窗可见和部分输入框可见
      this.formVisible = true
      this.inputVisible = true
      //填充警报规则数据
      this.listAlertRules(parseInt(row.id))
      //得到行号，方便更新成功之后更新列表中的数据
      this.index = index
      this.keyVisible = false
      this.keyVisibleForB = false
      //默认警报的keywords增加按钮被禁用
      if (this.form.type === 2) {
        this.keyVisibleForB = true
        this.keyVisible = true
      }
    },
    //根据警报ID列出警报规则
    async listAlertRules(alertID) {
      const response = await Apis.AlertRule.getAlertRules(alertID)
      let alertRules = response.data;
      alertRules = alertRules || []
      for (let i = 0; i < alertRules.length; i++) {
        const alertRule = alertRules[i];
        this.ruleTable.push({
          timeThreshold: alertRule.timeThreshold,
          countThreshold: alertRule.countThreshold,
          timeType: alertRule.timeType,
          resetLevel: alertRule.resetLevel,

          timeTypeValue: alertRule.timeTypeValue,
          resetLevelValue: alertRule.resetLevelValue,
        })
      }
    },
  },
  beforeMount: async function () {
    // 根据serviceID查找警报列表
    this.tableData = []
    const serviceID = parseInt(this.$route.params.serviceID);
    const projectID = parseInt(this.$route.params.projectID)
    const response = await Apis.Alert.getAlerts(serviceID);
    this.tableData = response.data || []
    // console.log(alerts)
    //根据serviceID查看serviceName
    const r1 = await Apis.Service.getService(serviceID)
    this.serviceName = r1.data.name
    //根据serviceID查看serviceName
    const r2 = await Apis.Project.getProject(projectID)
    this.projectName = r2.data.name

    //初始化公用的用户组数据
    const currentTeamID = this.$cookies.get("currentTeamID")
    const r3 = await Apis.UserGroup.getUserGroups(currentTeamID)
    const userGroups = [];
    const data = r3.data || []
    for (let i = 0; i < data.length; i++) {
      userGroups.push({
        id: r3.data[i].id,
        name: r3.data[i].name
      })
    }
    this.userGroups = userGroups
  }
}

</script>
<style scoped>
.el-tag + .el-tag {
  /*margin-left: 10px;*/
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.keyWordTag {
  margin: 4px;
}
</style>
